<section class="bestellungen-page">
    <header class="page-header">
        <h1>Tagesbestellung</h1>
        <p>Welche Bestellung muss als Nächstes bearbeitet werden?</p>

        @if (kritischCount() > 0) {
        <div class="critical-alert">
            <mat-icon fontSet="material-icons-outlined">
                warning
            </mat-icon>

            <span>
                {{ kritischCount() }} Bestellung erfordert sofortige Bearbeitung
            </span>
        </div>
        }
    </header>

    <section class="summary-grid" aria-label="Bestellstatus Übersicht">

        <button type="button" class="summary-card critical"
            [class.summary-card-active-critical]="isSummaryActive('KRITISCH')" (click)="setFilter('KRITISCH')">

            <strong>{{ kritischCount() }}</strong>
            <span>Kritisch</span>

        </button>

        <button type="button" class="summary-card"
            [class.summary-card-active-neutral]="isSummaryActive(BestellungStatus.Unbearbeitet)"
            (click)="setFilter(BestellungStatus.Unbearbeitet)">

            <strong>{{ unbearbeitetCount() }}</strong>
            <span>Unbearbeitet</span>

        </button>

        <button type="button" class="summary-card"
            [class.summary-card-active-orange]="isSummaryActive(BestellungStatus.InBearbeitung)"
            (click)="setFilter(BestellungStatus.InBearbeitung)">

            <strong>{{ inBearbeitungCount() }}</strong>
            <span>In Bearbeitung</span>

        </button>

        <div class="summary-card summary-card-disabled">
            <strong>{{ eilbestellungenCount() }}</strong>
            <span>Eilbestellungen</span>
        </div>

    </section>

    <section class="toolbar">

        <label class="filiale-select">

            <button type="button" class="filiale-trigger" (click)="toggleFilialeDropdown()">

                <mat-icon fontSet="material-icons-outlined">
                    storefront
                </mat-icon>

                <span>{{ selectedFilialeLabel() }}</span>

                <mat-icon class="select-arrow" fontSet="material-icons-outlined">

                    {{ isFilialeDropdownOpen() ? 'expand_less' : 'expand_more' }}

                </mat-icon>

            </button>

            @if (isFilialeDropdownOpen()) {

            <div class="filiale-dropdown">

                @for (filiale of filialen(); track filiale.value) {

                <button type="button" class="filiale-option"
                    [class.filiale-option-active]="selectedFiliale() === filiale.value"
                    (click)="selectFiliale(filiale.value)">

                    {{ filiale.label }}

                </button>

                }

            </div>

            }

        </label>

        <div class="filter-tabs">

            @for (filter of statusFilters(); track filter.value) {

            <button type="button" class="filter-tab" [class.filter-tab-active]="selectedFilter() === filter.value"
                (click)="setFilter(filter.value)">

                <span>{{ filter.label }}</span>
                <strong>{{ filter.count }}</strong>

            </button>

            }

        </div>

    </section>

    <section class="orders-table" aria-label="Bestellungen">
        <div class="table-scroll">
            <div class="table-header">

                <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('filiale')"
                    (click)="setSort('filiale')">

                    <span>Filiale</span>

                    <mat-icon fontSet="material-icons-outlined">
                        {{ getSortIcon('filiale') }}
                    </mat-icon>

                </button>

                <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('datum')"
                    (click)="setSort('datum')">

                    <span>Datum</span>

                    <mat-icon fontSet="material-icons-outlined">
                        {{ getSortIcon('datum') }}
                    </mat-icon>

                </button>

                <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('typ')"
                    (click)="setSort('typ')">

                    <span>Typ</span>

                    <mat-icon fontSet="material-icons-outlined">
                        {{ getSortIcon('typ') }}
                    </mat-icon>

                </button>

                <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('status')"
                    (click)="setSort('status')">

                    <span>Status</span>

                    <mat-icon fontSet="material-icons-outlined">
                        {{ getSortIcon('status') }}
                    </mat-icon>

                </button>

                <button type="button" class="sort-header restzeit-header"
                    [class.sort-header-active]="isSortActive('restzeit')" (click)="setSort('restzeit')">

                    <span>
                        <mat-icon fontSet="material-icons-outlined">
                            schedule
                        </mat-icon>
                        Restzeit
                    </span>

                    <mat-icon fontSet="material-icons-outlined">
                        {{ getSortIcon('restzeit') }}
                    </mat-icon>

                </button>

                <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('zeitraum')"
                    (click)="setSort('zeitraum')">

                    <span>Zeitraum</span>

                    <mat-icon fontSet="material-icons-outlined">
                        {{ getSortIcon('zeitraum') }}
                    </mat-icon>

                </button>

                <span>Aktion</span>

            </div>

            <div class="table-body">

                @if (isLoading()) {

                @for (row of skeletonRows; track $index) {

                <article class="table-row table-row-skeleton">

                    <div class="cell filiale-cell">
                        <span class="skeleton skeleton-text skeleton-text-strong"></span>
                        <span class="skeleton skeleton-text skeleton-text-small"></span>
                    </div>

                    <div class="cell">
                        <span class="skeleton skeleton-text skeleton-text-medium"></span>
                    </div>

                    <div class="cell">
                        <span class="skeleton skeleton-text skeleton-text-small"></span>
                    </div>

                    <div class="cell">
                        <span class="skeleton skeleton-pill"></span>
                    </div>

                    <div class="cell">
                        <span class="skeleton skeleton-text skeleton-text-medium"></span>
                    </div>

                    <div class="cell">
                        <span class="skeleton skeleton-text skeleton-text-medium"></span>
                    </div>

                    <div class="cell action-cell">
                        <span class="skeleton skeleton-button"></span>
                    </div>

                </article>

                }

                } @else if (filteredBestellungen().length === 0) {

                <div class="empty-state">
                    Keine Bestellungen für den gewählten Filter.
                </div>

                } @else {

                @for (bestellung of filteredBestellungen(); track bestellung.id) {

                <article class="table-row table-row-clickable" role="button" tabindex="0"
                    [class.row-critical]="isBestellungKritisch(bestellung)" (click)="openBestellung(bestellung)"
                    (keydown.enter)="openBestellung(bestellung)" (keydown.space)="openBestellung(bestellung)">

                    <div class="cell filiale-cell">
                        <strong>{{ bestellung.filialeName }}</strong>
                        <small>{{ bestellung.filialNummer }}</small>
                    </div>

                    <div class="cell">
                        <span>{{ bestellung.datum }}</span>
                    </div>

                    <div class="cell">
                        <span class="type-label" [class.type-warning]="bestellung.typ !== 'Standard'">

                            {{ bestellung.typ }}

                        </span>
                    </div>

                    <div class="cell">
                        <span class="status-pill"
                            [class.status-unbearbeitet]="bestellung.status === BestellungStatus.Unbearbeitet"
                            [class.status-in-bearbeitung]="bestellung.status === BestellungStatus.InBearbeitung"
                            [class.status-fertig]="bestellung.status === BestellungStatus.Fertig"
                            [class.status-abgeschlossen]="bestellung.status === BestellungStatus.Abgeschlossen">

                            {{ getStatusLabel(bestellung.status) }}

                        </span>
                    </div>

                    <div class="cell restzeit-cell" [class.critical-time]="isBestellungKritisch(bestellung)">

                        {{ getLiveRestzeit(bestellung) }}

                    </div>

                    <div class="cell zeitraum-cell">
                        <span>{{ bestellung.zeitraum }}</span>
                        <small>{{ bestellung.bestellzeitLabel }}</small>
                    </div>

                    <div class="cell action-cell">

                        <button type="button" class="open-button"
                            (click)="$event.stopPropagation(); openBestellung(bestellung)">

                            {{ getActionLabel(bestellung) }}

                        </button>

                        <button type="button" class="pdf-button" title="PDF herunterladen"
                            aria-label="PDF herunterladen" (click)="openBestellungPdf(bestellung, $event)">

                            <mat-icon fontSet="material-icons-outlined">
                                download
                            </mat-icon>

                        </button>

                    </div>

                </article>

                }

                }

            </div>
        </div>

    </section>

    <footer class="overview-footer">

        <span class="footer-item-inline">
            Gesamt:
            <strong>{{ totalCount() }}</strong>
        </span>

        <span class="footer-item-inline">
            Erledigt:
            <strong>
                {{ erledigtCount() }}/{{ totalCount() }}
                ({{ erledigtPercent() }}%)
            </strong>
        </span>

    </footer>

</section>